import {
    REQUEST_AVAILABLE_THEMES,
    RECEIVE_AVAILABLE_THEMES,
    ERROR_AVAILABLE_THEMES
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'

export default (state = initialFetchState, action = {}) => {
    switch(action.type) {
        case REQUEST_AVAILABLE_THEMES:
            return {
                ...state,
                isFetching: true,
                message: '',
                errors: {}
            }
        case RECEIVE_AVAILABLE_THEMES:
            return {
                ...state,
                isFetching: false,
                data: action.payload,
                message: action.message,
            }
        case ERROR_AVAILABLE_THEMES:
            return {
                ...state,
                isFetching: false,
                errors: action.errors
            }
        default:
            return state
    }
}